import type { IUser } from "@/domains/shared/models/IUser";
import { canAccessMultiManagerNav, isMultiManagerRoute } from "@/domains/multi/clinicMemberPaths";
import { ClinicRoles } from "@/domains/multi/clinicRoles";
import { NAV_AREA_LABEL_TRANSLATIONS } from "@/domains/shared/navigation/constants";
import { Roles } from "@/domains/shared/models/roles";
import { getTranslation } from "@mivo/i18n";

function isClinicFinanceOnlyMember(user: IUser): boolean {
    const clinicRoles = user.clinicRoles ?? [];
    return Boolean(
        user.activeClinicId
        && user.role === Roles.Therapist
        && clinicRoles.includes(ClinicRoles.Finance)
        && !clinicRoles.includes(ClinicRoles.Therapist),
    );
}

export function resolveNavAreaLabel(
    pathname: string,
    user: IUser | null | undefined,
): string {
    if (!user) {
        return "";
    }

    if (user.role === Roles.Admin) {
        return getTranslation(NAV_AREA_LABEL_TRANSLATIONS.admin);
    }

    if (user.role === Roles.Secretary) {
        return getTranslation(NAV_AREA_LABEL_TRANSLATIONS.secretary);
    }

    if (user.role === Roles.Therapist) {
        if (isClinicFinanceOnlyMember(user)) {
            return getTranslation(NAV_AREA_LABEL_TRANSLATIONS.finance);
        }

        if (isMultiManagerRoute(pathname) && canAccessMultiManagerNav(user)) {
            return getTranslation(NAV_AREA_LABEL_TRANSLATIONS.clinic);
        }

        return getTranslation(NAV_AREA_LABEL_TRANSLATIONS.professional);
    }

    return getTranslation(NAV_AREA_LABEL_TRANSLATIONS.parent);
}
